import type { FetchResponse } from 'ofetch'
import { ExceptionApiGeneral } from '~/data/exceptions/ExceptionApiGeneral'
import { ExceptionApiNotFound } from '~/data/exceptions/ExceptionApiNotFound'
import { ExceptionApiAccessTokenExpired } from '~/data/exceptions/ExceptionApiAccessTokenExpired'
import { ExceptionApiForbidden } from '~/data/exceptions/ExceptionApiForbidden'

const FORBIDDEN_MESSAGE = 'Forbidden'

const genertateApiExceptionByStatusCode = (
  statusCode: number,
  message: string,
) => {
  switch (statusCode) {
    case EXCEPTION_STATUS_CODE.UNAUTHORIZED:
      return new ExceptionApiAccessTokenExpired()
    case EXCEPTION_STATUS_CODE.BAD_REQUEST:
      // todo refresh token expired관련 처리?
      return new ExceptionApiGeneral(message)
    case EXCEPTION_STATUS_CODE.NOT_FOUND:
      return new ExceptionApiNotFound(message)
    case EXCEPTION_STATUS_CODE.FORBIDDEN:
      return new ExceptionApiForbidden(message)
    case EXCEPTION_STATUS_CODE.GENERAL:
      // artist-aggregator 는 무효 토큰 등 다운스트림 403 을 500 + message "Forbidden" 으로 감싸 응답한다 (WP-6337)
      return message === FORBIDDEN_MESSAGE
        ? new ExceptionApiForbidden(message)
        : new ExceptionApiGeneral(message)
    default:
      return new ExceptionApiGeneral(message)
  }
}

export const generateApiException = (response?: FetchResponse<any>) => {
  if (!response) {
    return new ExceptionApiGeneral()
  }

  const statusCode = response._data.fail?.status ?? response.status
  const message =
    response._data.fail?.message ??
    response._data.error?.message ??
    response.statusText

  return genertateApiExceptionByStatusCode(statusCode, message)
}
